import {convertCoordinates} from '@/api/util-coordinates';

class TownApiResponseModel {
  // #region Props

  // #endregion
  constructor({
    id,
    codIne,
    name,
    province,
    region,
    population,
    area,
    height,
    provinceId,
    popPlus25k,
    pop5kto25k,
    pop1kto5k,
    popMinus1k,
    coordinateX,
    coordinateY,
    // visible,
  },
  locale = 'es-ES',
  ) {
    const populationNumberFormat = new Intl.NumberFormat(locale, {
      style: 'decimal',
      maximumFractionDigits: 0,
    });
    const areaNumberFormat = new Intl.NumberFormat(locale, {
      style: 'decimal',
      maximumFractionDigits: 2,
    });
    const heightNumberFormat = new Intl.NumberFormat(locale, {
      style: 'decimal',
      maximumFractionDigits: 0,
    });
    return {
      id,
      ineCode: codIne,
      name,
      province,
      region,
      population: population == null ? 'N/A' : populationNumberFormat.format(population),
      area: area == null ? 'N/A' : areaNumberFormat.format(area),
      height: height == null ? 'N/A' : heightNumberFormat.format(height),
      provinceId,
      popPlus25k,
      pop5kto25k,
      pop1kto5k,
      popMinus1k,
      coordinates: convertCoordinates(coordinateX, coordinateY),
      visible: false, // TODO: Quitar cuando esté en la api
    };
  }
}

export default TownApiResponseModel;
